import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/report';

@Component
export default class tableMixin extends Vue {
  public iList: any = [];

  public column: Array<ITABLECOLCONF> = [{
    label: '用户名',
    prop: 'loginUserEmpName',
    align: 'center',
  }, {
    label: '登录名',
    prop: 'loginName',
    align: 'center',
  }, {
    label: 'IP',
    prop: 'loginIp',
    align: 'center',
  }, {
    label: '地址',
    prop: 'address',
    align: 'center',
  }, {
    label: '登录方式',
    prop: 'loginWay',
    align: 'center',
  }, {
    label: '定位方式',
    prop: 'positioningWay',
    align: 'center',
  }, {
    label: '所属机构',
    prop: 'loginUserOrgName',
    align: 'center',
  }, {
    label: '登陆时间',
    prop: 'loginTime',
    align: 'center',
  }]

  private loading: boolean = false;

  /**
   * @author liangyongmou
   * @desc 获取ip地址统计表
   * @param param
   */
  getData(param?: any) {
    this.loading = true;
    api.getList(param).then((res:any) => {
      this.iList = res;
      this.iList.forEach((ele: any, index: number) => {
        this.iList[index].address = `${ele.province ? ele.province : ''}${ele.city ? ele.city : ''}${ele.area ? ele.area : ''}${ele.loginAddress ? ele.loginAddress : ''}`;
        if (ele.positioningWay) {
          this.iList[index].positioningWay = 'h5';
        } else if (ele.positioningWay === 0) {
          this.iList[index].positioningWay = 'ip';
        } else {
          this.iList[index].positioningWay = '';
        }
        if (ele.loginWay) {
          this.iList[index].loginWay = '微信';
        } else if (ele.loginWay === 0) {
          this.iList[index].loginWay = 'pc';
        } else {
          this.iList[index].loginWay = '';
        }
      });
      this.loading = false;
    });
  }
}
